import React, { useState } from "react";
import { IoPersonSharp } from "react-icons/io5";
import { MdOutlineWaterDrop } from "react-icons/md";
import { CiTrash } from "react-icons/ci";

import "./Room-Details-Card.scss";

import RoomImage from "../../../assets/images/room-image.jpeg";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const RoomDetailsCard = ({
  propertyDetails,
  isSqueezed,
  setIsSqueezed,
  setSelectedProperty,
  onCardClick, // NEW: callback for card click
}) => {
  const [propertyName, setPropertyName] = useState("");

  const RoomDetailsCardStyle = {
    width: vw(350),
    borderRadius: vw(10),
    padding: vh(10),
    // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid #dcdcdc",
    backgroundColor: "#ffffff",
    fontFamily: "Karla, sans-serif",
    transition: "width 0.5s, height 0.5s",
  };
  const squezzedRoomDetailsCardStyle = {
    width: vw(350),
    borderRadius: vw(10),
    padding: vh(10),
    // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid #dcdcdc",
    backgroundColor: "#ffffff",
    fontFamily: "Karla, sans-serif",
    height: vh(150),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };
  const imagePlaceholderStyle = {
    width: "100%",
    height: vh(150),
    border: "1px solid #dcdcdc",
    borderRadius: vw(5),
    marginBottom: vh(15),
    objectFit: "cover", // Ensures the image covers the container while maintaining aspect ratio
    overflow: "hidden", // Hides the excess parts of the image
  };
  const squezzedImagePlaceholderStyle = {
    width: vw(110),
    height: "100%",
    borderRadius: vw(10),
    transition: "width 0.7s, height 0.7s",
  };

  const RoomDetailsCardContentStyle = {
    textAlign: "left",
    margin: `0px ${vw(10)}`,
    transition: "width 0.5s, height 0.5s",
  };

  const squezzedRoomDetailsCardContentStyle = {
    width: "60%",
    paddingTop: vh(20),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  };

  const titleStyle = {
    fontSize: vh(18),
    margin: "0",
    color: "#333333",
  };

  const locationStyle = {
    color: "#d2a679",
    fontSize: vh(14),
    marginBottom: "10px",
  };

  const detailsStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: vh(15),
    fontSize: vh(14),
    color: "#333333",
  };
  const squezzedDetailsStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: vh(15),
    fontSize: vh(14),
    color: "#333333",
    width: "70%",
    flexDirection: "column",
    gap: vw(8),
  };

  const iconTextStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: vh(12),
  };

  const priceStyle = {
    fontSize: vh(16),
    fontWeight: "bold",
    color: "#333333",
  };

  //data fetch
  const formatHouseType = (houseType) => {
    const houseTypeMap = {
      single_room: "Single Room",
      bedsitter: "Bed Sitter",
      one_bedroom: "One Bedroom",
      two_bedrooms: "Two Bedroom",
      three_bedrooms: "Three Bedroom",
    };

    return houseTypeMap[houseType] || houseType;
  };

  return (
    <div className="room-details-card-container-overview-admin">
      <div
        className="room-card-admin"
        style={isSqueezed ? { height: vh(150) } : {}}
      >
        <div
          className="front"
          onClick={() => {
            if (onCardClick) {
              onCardClick();
              return;
            }
            if (setIsSqueezed) {
              setIsSqueezed(!isSqueezed);
            }
            if (setSelectedProperty) {
              setSelectedProperty(propertyDetails);
              window.scrollTo({
                top: 0,
                behavior: "smooth", // For smooth scrolling
              });
            }
          }}
        >
          <div
            style={
              isSqueezed ? squezzedRoomDetailsCardStyle : RoomDetailsCardStyle
            }
          >
            <div
              style={
                isSqueezed
                  ? {
                      ...squezzedImagePlaceholderStyle,
                      backgroundImage: `url(${propertyDetails?.images[0]})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }
                  : {
                      ...imagePlaceholderStyle,
                      backgroundImage: `url(${propertyDetails?.images[0]})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }
              }
            />
            <div
              style={
                isSqueezed
                  ? squezzedRoomDetailsCardContentStyle
                  : RoomDetailsCardContentStyle
              }
            >
              <h2 style={titleStyle}>{propertyDetails?.name}</h2>
              <div style={locationStyle}>{propertyDetails?.location}</div>
              <div style={isSqueezed ? squezzedDetailsStyle : detailsStyle}>
                <span style={iconTextStyle}>
                  <IoPersonSharp
                    fontSize={vh(15)}
                    style={{ marginRight: vw(10) }}
                  />
                  <div className="">
                    {propertyDetails?.occupiedHouses} Tenants
                  </div>
                </span>
                <span style={iconTextStyle}>
                  <MdOutlineWaterDrop
                    fontSize={vh(15)}
                    style={{ marginRight: vw(6) }}
                  />
                  {propertyDetails?.water_charge} ksh/unit
                </span>
                <span style={iconTextStyle}>
                  <CiTrash fontSize={vh(15)} style={{ marginRight: vw(6) }} />
                  {propertyDetails?.garbage_charge} ksh
                </span>
              </div>
              {/* <div style={priceStyle}>ksh { houseDetails?.house_rent}</div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomDetailsCard;
